<script setup lang="ts">
interface Props {
  step: '1' | '2' | '3'
  flip?: boolean
}

const props = defineProps<Props>()

const { isRtl } = useLayout()
const realFlip = computed(() => isRtl.value ? !props.flip : props.flip)

const el = ref()
const visible = ref(false)
useIntersectionObserver(
  el,
  ([{ isIntersecting }]) => {
    if (!visible.value) {
      visible.value = isIntersecting
    }
  },
  { threshold: 0.4 },
)
</script>

<template>
  <div
    ref="el" flex="~ col-reverse shrink-0"
    class="[justify-content:start] items-center rd-8px all:transition-all-1500"
    :md="realFlip ? 'flex-row-reverse rtl:flex-row' : 'flex-row rtl:flex-row-reverse'"
    lt-md="bg-clip-[padding-box,border-box] bg-origin-[padding-box,border-box] b b-solid b-transparent of-hidden text-center w-full px-20px bg-image-[linear-gradient(#1D1B31,#1D1B31),linear-gradient(300deg,transparent_71%,#fff3)]"
  >
    <div
      class="relative z-2 rd-8px" b="~ solid transparent" p="b-24px md:40px"
      bg="clip-[padding-box,border-box] origin-[padding-box,border-box]"
      :class=" visible ? 'op-100' : `op-0 ${flip ? 'translate-x-50px' : 'translate-x--50px'}`"
      :md="flip
        ? 'rd-lb-0 bg-image-[linear-gradient(#1D1B31,#1D1B31),linear-gradient(-300deg,transparent_71%,#fff3)]'
        : 'rd-rb-0 bg-image-[linear-gradient(#1D1B31,#1D1B31),linear-gradient(300deg,transparent_71%,#fff3)]'"
    >
      <h2 class="c-#fff font-800" mb="16px md:20px" text="18px md:32px" lh="28px md:40px" v-html="$t(`home_page.introduce_title_${step}`)" />
      <span
        class="text-justify c-#ffffff80 tracking-wide"
        text="14px md:18px" lh="20px md:26px"
        v-html=" $t(`home_page.introduce_des_${step}`)"
      />

      <div
        :md="flip ? 'odd:left--30px scale-x--100' : 'right--30px'"
        class="absolute inset-be-0 size-30px bg-gradient-to-rt"
        stops="[#1D1B31_0_50%,transparent_50%_100%]"
      />
    </div>

    <div
      class="relative aspect-ratio-59/56 w-full flex-shrink-0" md="aspect-ratio-165/137 max-w-600px w-50vw"
      :class="visible ? 'op-100' : `op-0 ${flip ? 'translate-x--50px' : 'translate-x-50px'}`"
    >
      <LdImage
        class="absolute-center aspect-ratio-165/137 w-100vw" md="max-w-600px w-50vw"
        :src="getPublicImg(`home/introduce-img-${step}.webp`)" alt=""
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
